import { createStyles, makeStyles } from '@material-ui/core/styles';
import Login from '../../assets/images/login_2.jpg';

import { colors } from '../../styles';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    root: {
      height: '100vh',
    },
    image: {
      background: `linear-gradient(0deg, rgba(0, 0, 0, 0.95), rgba(0, 0, 0, 0.7)), url(${Login})`,
      backgroundRepeat: 'no-repeat',
      backgroundColor:
        theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      padding: '5vw',
    },
    text: {
      color: colors.white,
      fontFamily: 'Montserrat',
      fontSize: '3.2em',
      fontWeight: 500,
    },
    author: {
      color: colors.white,
      fontFamily: 'Montserrat',
      fontSize: '1.5em',
      fontWeight: 300,
      textAlign: 'right',
    },
    paper: {
      display: 'flex',
      height: '100%',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    slackButton: {
      margin: theme.spacing(5, 0, 0),
    },
  })
);
